export default {
  NotCreated: 0, // Chưa tổng hợp
  Created: 1, // Đã tổng hợp
  Sent: 2, // Đã nộp
  Approved: 3, // Cấp trên đã nhận
  Rejected: 4, // Cấp trên từ chối
};
